import { changeIntegrationUseCases } from 'actions/integrationSettings';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getIntegrationSettingsForm } from 'selectors/integrationSettings';
import { useSelector } from 'store';

export const useCasesOptions = [
  {
    value: '8e09c0d2-dc34-5e85-96c4-40e60a48890e',
    label: 'Antitrust',
  },
  {
    value: '3dee7b30-b9f6-414a-b37b-545033cf185e',
    label: 'Anti-bribery & Anti-Corruption',
  },
  {
    value: '24303aa2-5f26-48f2-a38a-72a18509214e',
    label: 'Culture',
  },
  {
    value: '6f5dccbe-0eaa-4ff4-86f2-ded954fb9c2c',
    label: 'Code of Conduct',
  },
];

const IntegrationSettingsUseCases: React.FC = () => {
  const dispatch = useDispatch();

  const { use_case_uuids: useCases = [] } = useSelector(getIntegrationSettingsForm);

  const handleUseCasesChange = (value: string): void => {
    if (useCases.includes(value)) {
      dispatch(changeIntegrationUseCases(useCases.filter((u) => u !== value)));
    } else {
      dispatch(changeIntegrationUseCases([...useCases, value]));
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2 bg-white">
        <div>
          <span>Use Cases</span>
        </div>
        <div className="flex flex-col gap-2">
          {useCasesOptions.map((u) => (
            <label
              htmlFor={`${u.value}-checkbox`}
              className="inline-flex flex-row  gap-2 text-body items-center"
              key={u.value}
            >
              <input
                id={`${u.value}-checkbox`}
                type="checkbox"
                name={u.value}
                className="form-checkbox litlingo-checkbox h-4 w-4 transition duration-150 ease-in-out"
                onChange={(): void => handleUseCasesChange(u.value)}
                checked={useCases.includes(u.value)}
              />
              <div className="flex flex-row gap-1 text-body">{u.label}</div>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntegrationSettingsUseCases;
